import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

import FilterHeader from '../../FilterHeader';
import Filter from './Filter';

export const Wrapper = styled.ul`
    visibility: ${({ hidden }) => hidden ? 'hidden' : 'visible'};
    padding: ${({ theme }) => theme.pageTemplate?.paddingLeftRight?.md};

    ${media.lgmin`
        padding-right: 20px;
        padding-left: ${({ theme }) => theme.pageTemplate?.paddingLeftRight?.lg};
    `}
`;

const Section = styled.li`
    margin-bottom: 16px;
`;

export const Header = styled.h3`
    border-bottom: 1px solid ${COLORS.mlbGrey6};
    padding-bottom: 12px;
    font-family: ${({ theme }) => theme.fonts?.family?.primary};
    font-size: 24px;
    font-weight: bold;
    color: ${({ theme }) => theme.primaryTextColor};
`;

const FilterWrapper = styled.li`
    margin-bottom: 16px;
    grid-column: ${({ narrow }) => narrow ? 'auto' : '1/3'};
`;

const Filters = styled.ul`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${({ theme }) => theme.filter?.columnGap};
`;

const List = (props) => {

    const {
        loading,
        data,
        selectedFilters,
        addSelectedFilter,
        removeSelectedFilter,
        hide,
        filtersConfig,
    } = props;

    const fieldsData = data.fields || [];

    if (loading) {

        return null;

    }

    return (
        <Wrapper hidden={hide}>
            {filtersConfig.map((group) => (
                <Section key={group.name}>
                    <Header>{group.name}</Header>
                    <Filters>
                        {group.filters.map((filterConfig, index) => (
                            <FilterWrapper key={index} narrow={filterConfig.narrow}>
                                <FilterHeader text={filterConfig.filterName} />
                                <Filter
                                    fieldsData={fieldsData}
                                    filterConfig={filterConfig}
                                    activeFilters={selectedFilters}
                                    addSelectedFilter={addSelectedFilter}
                                    removeSelectedFilter={removeSelectedFilter}
                                />
                            </FilterWrapper>
                        ))}
                    </Filters>
                </Section>
            ))}
        </Wrapper>
    );

};

List.propTypes = {
    loading: PropTypes.bool.isRequired,
    data: PropTypes.object,
    selectedFilters: PropTypes.array.isRequired,
    addSelectedFilter: PropTypes.func.isRequired,
    removeSelectedFilter: PropTypes.func.isRequired,
    hide: PropTypes.bool,
    filtersConfig: PropTypes.array.isRequired,
};

List.defaultProps = {
    hide: false,
    data: {},
};

export default List;
